import React, { useState } from "react";
import "./ContactSection.css";
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';

function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const { t } = useTranslation();
  return (
    <section className="contact-section" id="contact">
      <div className="contact-split-container">
        {/* Left: Info Cards */}
        <div className="contact-info-col contact-cards-col">
          <div className="contact-card">
            <div className="contact-card-icon address">
              {/* Location SVG */}
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="10" r="3.8" stroke="#fff" strokeWidth="2" fill="none"/>
                <path d="M12 21c-5.5-7.1-7-9.4-7-12.1C5 5.1 8.1 2 12 2s7 3.1 7 6.9c0 2.7-1.5 5-7 12.1z" stroke="#fff" strokeWidth="2" fill="none"/>
              </svg>
            </div>
            <div className="contact-card-content">
              <div className="contact-card-title">{t('contact_address_title')}</div>
              <div className="contact-card-text">
                <a href="https://maps.app.goo.gl/jZdXwfBT6vYFvohWA" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>
                  Bhayer, Hammam Sousse, Tunisie
                </a>
              </div>
              <div className="contact-card-hint">
                <a href="https://maps.app.goo.gl/jZdXwfBT6vYFvohWA" target="_blank" rel="noopener noreferrer" style={{ color: "#f59e0b", textDecoration: "none", fontSize: "0.85rem" }}>
                  {t('contact_address_hint')}
                </a>
              </div>
            </div>
          </div>
          <div className="contact-card">
            <div className="contact-card-icon email">
              {/* Paper Plane SVG */}
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 20l18-8-18-8v6l14 2-14 2v6z" fill="none" stroke="#fff" strokeWidth="2" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-card-content">
              <div className="contact-card-title">{t('contact_email_title')}</div>
              <div className="contact-card-text">
                <a href="mailto:info@proconnet.tn" style={{ color: "inherit", textDecoration: "none" }}>
                  info@proconnet.tn
                </a>
              </div>
            </div>
          </div>
          <div className="contact-card">
            <div className="contact-card-icon phone">
              {/* Phone SVG */}
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 3 5.18 2 2 0 0 1 5 3h3a2 2 0 0 1 2 1.72c.13 1.13.47 2.22 1 3.22a2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6.29 6.29l1.27-1.27a2 2 0 0 1 2.11-.45c1 .53 2.09.87 3.22 1A2 2 0 0 1 22 16.92z" stroke="#fff" strokeWidth="2" fill="none" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-card-content">
              <div className="contact-card-title">{t('contact_phone_title')}</div>
              <div className="contact-card-text">{t('contact_phone')}</div>
            </div>
          </div>
          <div className="contact-card whatsapp-card">
            <div className="contact-card-icon whatsapp">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </div>
            <div className="contact-card-content">
              <div className="contact-card-title">WHATSAPP (DE)</div>
              <div className="contact-card-text">{t('contact_phone_de')}</div>
            </div>
          </div>
        </div>
        {/* Right: Form */}
        <div className="contact-form-col contact-form-side">
          <div className="contact-form-heading">{t('contact_form_heading')}</div>
          {submitted ? (
            <div className="thank-you-message" style={{padding: '2rem', fontSize: '1.3rem', color: '#2563eb', textAlign: 'center'}}>
              {t('contact_thank_you')}
            </div>
          ) : (
            <form className="contact-form"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.target;
                try {
                  await emailjs.send(
                    'service_ejp9yls',
                    'template_kh15ygz',
                    {
                      name: form.name.value,
                      number: form.phone.value,
                      company: form.company.value,
                      email: form.email.value,
                      message: form.message.value,
                    },
                    'jZcEOC-MBU3QvAubg'
                  );
                  setSubmitted(true);
                  form.reset();
                } catch (err) {
                  alert(t('contact_error'));
                }
              }}>
              <input type="text" name="name" placeholder={t('contact_name_placeholder')} required />
              <input type="tel" name="phone" placeholder={t('contact_phone_placeholder')} />
              <input type="text" name="company" placeholder={t('contact_company_placeholder')} />
              <input type="email" name="email" placeholder={t('contact_email_placeholder')} required />
              <textarea name="message" placeholder={t('contact_message_placeholder')} rows="6" required></textarea>
              <button type="submit" className="contact-submit">{t('contact_send_btn')}</button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
